module.exports = __webpack_public_path__ + "static/media/iis.046d68fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/iis.png
// module id = 117
// module chunks = 0